import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useOnLazyPageLoad } from "../../hooks/useOnAppLoad";
export const LazyPageLoadProvider = ({ children = null }) => {
    useOnLazyPageLoad();
    return _jsx(_Fragment, { children: children }, void 0);
};
//# sourceMappingURL=LazyPageLoadProvider.js.map